export const PERMISSION_MODELS = Object.freeze({
  USER: 'user',
  PRODUCT: 'product',
  ORDER: 'order',
  LEAD: 'lead',
  SUBSCRIPTION: 'subscription',
  CASE: 'case',
  PATIENT: 'patient',
  PRESCRIPTION: 'prescription',
  STATUS: 'status',
  TICKET: 'ticket',
  VOUCHER: 'voucher',
  QUESTIONNAIRE: 'product_questionnaire',
  ACTIVITY: 'activity',
  NOTE: 'note',
  CONTACT: 'contact',
  DASHBOARD: 'dashboard',
  TEAMS: 'team',
  HIGHLEVEL_LEADS: 'HighLevel::Leads',
  MDI_LEADS: 'Mdi::Leads',
  TELEGRAMD_LEADS: 'Telegramd::Leads',
  GETHEALTHIE_LEADS: 'Gethealthie::Leads',
  TELEGRAMD_CASES: 'Telegramd::Cases',
  EXTERNAL_TOKENS: 'external_token',
  PHARMACY_TRACKINGS: 'pharmacy_tracking',
  TEMPLATE: 'template',
  SCHEDULED_JOB: 'schedule_job',
  GMAIL: 'Support::Gmails',
  TYPE: 'type',
  CHARGE: 'charge',
  EXPORT: 'export',
  APPOINTMENT: 'appointment',
  FOLLOW_UP: 'follow_up',
  ROLE: 'role',
  ROLE_PERMISSON: 'role_permission',
  LAB_ORDER: 'lab_order',
  ADDRESS: 'address',
  CATEGORY: 'category',
  PROMOTION_CODE: 'promotion_code',
  QUIZ_ATTEMPTS: 'quiz_attempt',
  AGENT_SALES: 'agent_sale',
  PRODUCT_VARIANT: 'product_variant',
  AVAILABLE_PRODUCT_VARIANT: 'available_product_variant',
  CONVERSATION: 'conversation',
  EXTERNAL_COMMUNICATION_LOG: 'external_communication_log',
  USER_DEVICE: 'user_device',
  CREDIT_TRANSACTION: 'credit_transaction',
  LAB_REVIEW: 'lab_review',
  ANTHROPOMETRY_MEASUREMENT: 'anthropometry_measurement',
  CHECKOUT_SESSION: 'checkout_session',
  INTAKE: 'intake',
  NOTIFICATION: 'notification',
  USER_FILTER: 'user_filter',
  SHOPIFY_SUBSCRIPTIONS: 'Shopify::Subscriptions',
  SUPPORT_TEMPLATES: 'support_template',
  ABSENCE_REQUEST: 'absence_request',
  PHARMACY: 'pharmacy',
});

const DEFAULT_PERMISSION_ACTIONS = {
  SHOW: 'show',
  INDEX: 'index',
  CREATE: 'create',
  UPDATE: 'update',
};

export const PERMISSIONS_STRUCT = {
  LEAD: {
    NAME: PERMISSION_MODELS.LEAD,
    ACTIONS: {
      NOTES: 'notes',
      FETCH_TEMPLATES: 'fetch_templates',
      MERGE_LEAD: 'merge_lead',
      SYNC_LEAD: 'sync',
      RESOLVE_TICKET: 'resolve_ticket',
      OPEN_TICKET: 'open_ticket',
      ORDERS: 'orders',
      UNTRACK_CASES: 'untrack_cases',
      LIST_TICKETS: 'list_tickets',
      PRODUCTS: 'products',
      PRODUCT_VARIANTS: 'product_variants',
      LAB_ORDERS: 'lab_orders',
      SYNC_APPOINTMENTS: 'sync_appointments',
      CRM_CONVERSATION: 'crm_conversation',
      BUILD_PAYMENT_REQUEST: 'build_payment_request',
      LAB_DOCUMENTS: 'lab_documents',
      UPLOAD_LAB_DOCUMENTS: 'upload_lab_documents',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  PATIENT: {
    NAME: PERMISSION_MODELS.PATIENT,
    ACTIONS: {
      CONTACTS: 'contacts',
      DESTROY: 'destroy',
      MEASUREMENTS: 'measurements',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  ORDER: {
    NAME: PERMISSION_MODELS.ORDER,
    ACTIONS: {
      MARK_AS_PURCHASE: 'mark_as_purchase',
      MARK_AS_ADJUSTMENT: 'mark_as_adjustment',
      GENERATE_MANUAL_ORDER: 'generate_manual_order',
      UPDATE_MANUAL_ORDER: 'update_manual_order',
      DELETE_MANUAL_ORDER: 'delete_manual_order',
      RETRY_DIAGNOSTICS_ORDER: 'retry_diagnostics_order',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  CASE: {
    NAME: PERMISSION_MODELS.CASE,
    ACTIONS: {
      NOTES: 'notes',
      MARK_AS_DELIVERED: 'mark_as_delivered',
      PRESCRIPTIONS: 'prescriptions',
      TRACKINGS: 'trackings',
      LINK_CHARGE: 'link_charge',
      UNLINK_CHARGE: 'unlink_charge',
      PAUSE_FOLLOWUP: 'pause_followup',
      MARK_MAIN_PRODUCT: 'mark_main_product',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  STATUS: {
    NAME: PERMISSION_MODELS.STATUS,
    ACTIONS: {
      BATCH_SORT_POSITIONS: 'batch_sort_positions',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  PRODUCT: {
    NAME: PERMISSION_MODELS.PRODUCT,
    ACTIONS: {
      SYNC_PRODUCT: 'sync',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  SUBSCRIPTION: {
    NAME: PERMISSION_MODELS.SUBSCRIPTION,
    ACTIONS: {
      CANCEL_SUBSCRIPTION: 'cancel_subscription',
      RESUME_SUBSCRIPTION: 'resume_subscription',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  USER: {
    NAME: PERMISSION_MODELS.USER,
    ACTIONS: {
      FETCH_SALE_STATISTICS: 'fetch_sale_statistics',
      REVOKE_USER_DEVICES: 'revoke_user_devices',
      UNREVOKE_USER_DEVICES: 'unrevoke_user_devices',
      ACTIVATE_ACCOUNT: 'activate_account',
      DEACTIVATE_ACCOUNT: 'deactivate_account',
      CONFIRM_EMAIL_MANUALLY: 'confirm_email_manually',
      UNREAD_NOTIFICATION_COUNT: 'unread_notifications_count',
      UPDATE_USER_COLUMNS: 'update_user_columns',
      NEW: 'new',
      AFFILIATE_INFO: 'affiliate_info',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  TICKET: {
    NAME: PERMISSION_MODELS.TICKET,
    ACTIONS: {
      ASSIGN_TICKET: 'assign_ticket',
      FOLLOW_UPS: 'follow_ups',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  QUESTIONNAIRE: {
    NAME: PERMISSION_MODELS.QUESTIONNAIRE,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  VOUCHER: {
    NAME: PERMISSION_MODELS.VOUCHER,
    ACTIONS: {
      INTAKE_APPOINTMENT: 'intake_appointment',
      SEND_APPOINTMENT_BOOKING_LINK: 'send_appointment_booking_link',
      EXPIRE_VOUCHER: 'expire_voucher',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  ACTIVITY: {
    NAME: PERMISSION_MODELS.ACTIVITY,
    ACTIONS: {
      FETCH_ACTIVITIES: 'fetch_activities',
    },
  },
  NOTE: {
    NAME: PERMISSION_MODELS.NOTE,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  CONTACT: {
    NAME: PERMISSION_MODELS.CONTACT,
    ACTIONS: {
      SYNC: 'sync',
      DESTROY: 'destroy',
      MARK_AS_FIXED: 'mark_as_fixed',
      MARK_AS_UNFIXED: 'mark_as_unfixed',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  DASHBOARD: {
    NAME: PERMISSION_MODELS.DASHBOARD,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  PHARMACY: {
    NAME: PERMISSION_MODELS.PHARMACY,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  PRESCRIPTION: {
    NAME: PERMISSION_MODELS.PRESCRIPTION,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  TEAMS: {
    NAME: PERMISSION_MODELS.TEAMS,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
      DESTROY: 'destroy',
    },
  },
  HIGHLEVEL_LEADS: {
    NAME: PERMISSION_MODELS.HIGHLEVEL_LEADS,
    ACTIONS: {
      VIEW_MESSAGES: 'messages',
      SEND_MESSAGE: 'send_message',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  MDI_LEADS: {
    NAME: PERMISSION_MODELS.MDI_LEADS,
    ACTIONS: {
      SEND_MESSAGE: 'send_message',
      VIEW_MESSAGES: 'messages',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  TELEGRAMD_LEADS: {
    NAME: PERMISSION_MODELS.TELEGRAMD_LEADS,
    ACTIONS: {
      VIEW_MESSAGES: 'messages',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  GETHEALTHIE_LEADS: {
    NAME: PERMISSION_MODELS.GETHEALTHIE_LEADS,
    ACTIONS: {
      CONVERSATIONS: 'conversations',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },

  TELEGRAMD_CASES: {
    NAME: PERMISSION_MODELS.TELEGRAMD_CASES,
    ACTIONS: {
      SUBMIT: 'submit',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  EXTERNAL_TOKENS: {
    NAME: PERMISSION_MODELS.EXTERNAL_TOKENS,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
      DESTROY: 'destroy',
    },
  },
  PHARMACY_TRACKINGS: {
    NAME: PERMISSION_MODELS.PHARMACY_TRACKINGS,
    ACTIONS: {
      NEW: 'new',
      ENSURE_TRACKING: 'ensure_tracking',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  TEMPLATE: {
    NAME: PERMISSION_MODELS.TEMPLATE,
    ACTIONS: {
      DESTROY: 'destroy',
      FETCH_HTML_BODY: 'fetch_html_body',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  SCHEDULED_JOB: {
    NAME: PERMISSION_MODELS.SCHEDULED_JOB,
    ACTIONS: {
      CANCEL_SCHEDULE_JOB: 'cancel_schedule_job',
      RESCHEDULE_JOB: 'reschedule_job',
      SCHEDULE_NOW: 'schedule_now',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  GMAIL: {
    NAME: PERMISSION_MODELS.GMAIL,
    ACTIONS: {
      INDEX: 'messages',
      MODIFY_MESSAGE: 'modify_messages',
      SEND_MESSAGE: 'send_message',
      FETCH_ATTACHMENT: 'fetch_attachment',
    },
  },
  TYPE: {
    NAME: PERMISSION_MODELS.TYPE,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  CHARGE: {
    NAME: PERMISSION_MODELS.CHARGE,
    ACTIONS: {
      LAB_REVIEWS: 'lab_reviews',
      NEW_VOUCHER: 'new_voucher',
      VOUCHERS: 'vouchers',
      REFUND: 'refund',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  EXPORT: {
    NAME: PERMISSION_MODELS.EXPORT,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  INTAKE: {
    NAME: PERMISSION_MODELS.INTAKE,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  NOTIFICATION: {
    NAME: PERMISSION_MODELS.NOTIFICATION,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  USER_FILTER: {
    NAME: PERMISSION_MODELS.USER_FILTER,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  APPOINTMENT: {
    NAME: PERMISSION_MODELS.APPOINTMENT,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  FOLLOW_UP: {
    NAME: PERMISSION_MODELS.FOLLOW_UP,
    ACTIONS: {
      MARK_AS_COMPLETE: 'mark_as_complete',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  ROLE: {
    NAME: PERMISSION_MODELS.ROLE,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
      DESTROY: 'destroy',
    },
  },
  ROLE_PERMISSON: {
    NAME: PERMISSION_MODELS.ROLE_PERMISSON,
    ACTIONS: {
      FETCH_PERMISSIONS_SKELETON: 'fetch_premissions_skeleton',
    },
  },

  LAB_ORDER: {
    NAME: PERMISSION_MODELS.LAB_ORDER,
    ACTIONS: {
      NEW: 'new',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  ADDRESS: {
    NAME: PERMISSION_MODELS.ADDRESS,
    ACTIONS: {
      DESTROY: 'destroy',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  CATEGORY: {
    NAME: PERMISSION_MODELS.CATEGORY,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  PROMOTION_CODE: {
    NAME: PERMISSION_MODELS.PROMOTION_CODE,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
      SYNC: 'sync',
      DESTROY: 'destroy',
    },
  },
  AGENT_SALES: {
    NAME: PERMISSION_MODELS.AGENT_SALES,
    ACTIONS: {
      MY_SALES: 'my_sales',
      MARK_AS_COMPLETE: 'mark_as_complete',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  PRODUCT_VARIANT: {
    NAME: PERMISSION_MODELS.PRODUCT_VARIANT,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
      DESTROY: 'destroy',
    },
  },
  AVAILABLE_PRODUCT_VARIANT: {
    NAME: PERMISSION_MODELS.AVAILABLE_PRODUCT_VARIANT,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
      DESTROY: 'destroy',
    },
  },
  QUIZ_ATTEMPTS: {
    NAME: PERMISSION_MODELS.QUIZ_ATTEMPTS,
    ACTIONS: {
      DASHBOARD_STATS: 'dashboard_stats',
      QUIZ_CONFIG: 'quiz_config',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  CONVERSATION: {
    NAME: PERMISSION_MODELS.CONVERSATION,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  EXTERNAL_COMMUNICATION_LOG: {
    NAME: PERMISSION_MODELS.EXTERNAL_COMMUNICATION_LOG,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  USER_DEVICE: {
    NAME: PERMISSION_MODELS.USER_DEVICE,
    ACTIONS: {
      REVOKE: 'revoke',
      UNREVOKE: 'unrevoke',
    },
  },
  CREDIT_TRANSACTION: {
    NAME: PERMISSION_MODELS.CREDIT_TRANSACTION,
    ACTIONS: {
      INDEX: 'index',
      CANCEL_TRANSACTION: 'cancel_transaction',
    },
  },
  LAB_REVIEW: {
    NAME: PERMISSION_MODELS.LAB_REVIEW,
    ACTIONS: {
      DETACH_MANUALLY: 'detach_manually',
      MARK_AS_COMPLETE: 'mark_as_complete',
      SET_PANEL_CHARGE: 'set_panel_charge',
      SYNC_MANUALLY: 'sync_manually',
      NEW: 'new',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  ANTHROPOMETRY_MEASUREMENT: {
    NAME: PERMISSION_MODELS.ANTHROPOMETRY_MEASUREMENT,
    ACTIONS: {
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  CHECKOUT_SESSION: {
    NAME: PERMISSION_MODELS.CHECKOUT_SESSION,
    ACTIONS: {
      EXPIRE: 'expire',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  SHOPIFY_SUBSCRIPTIONS: {
    NAME: PERMISSION_MODELS.SHOPIFY_SUBSCRIPTIONS,
    ACTIONS: {
      RESCHEDULE_BILLINGS: 'reschedule_billings',
      UPDATE_PAYMENT_METHOD: 'update_payment_method',
    },
  },
  SUPPORT_TEMPLATES: {
    NAME: PERMISSION_MODELS.SUPPORT_TEMPLATES,
    ACTIONS: {
      DESTROY: 'destroy',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
  ABSENCE_REQUEST: {
    NAME: PERMISSION_MODELS.ABSENCE_REQUEST,
    ACTIONS: {
      RESOLVE_REQUEST: 'resolve_request',
      DESTROY: 'destroy',
      ...DEFAULT_PERMISSION_ACTIONS,
    },
  },
};
